import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".section1 .mySwiper", {
    spaceBetween: 6,
    slidesPerView: 5,
    direction: 'vertical',

});
var swiper2 = new Swiper(".section1 .mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
});

var swiper6 = new Swiper(".section6 .mySwiper", {
    navigation: {
        nextEl: ".section6 .swiper-button-next",
        prevEl: ".section6 .swiper-button-prev",
    },
    spaceBetween: '3.3125%',
    slidesPerView: 3,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: '3.3125%',
            slidesPerView: 3,
            slidesPerGroup:3,
        },
        768: {  //当屏幕宽度小于等于1280
            spaceBetween: '1.6875%',
            slidesPerView: 2,
            slidesPerGroup:2,
        },
        320: {  //当屏幕宽度小于等于320
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerGroup:1,
        }
    }, 
});